import * as React from 'react';
import { BaSeShapeButton } from '@base/react';

export const ImprimirCertificado = ({ url, color }) => {
  const [isLoading, setIsLoading] = React.useState(false);
  if (!url) return;

  const PDFBlobPrint = async () => {
    setIsLoading(true);
    const response = await fetch(url);
    const blob = await response.blob();

    const blobUrl = URL.createObjectURL(blob);
    const iframe = document.createElement('iframe');

    iframe.style.display = 'none';
    iframe.src = blobUrl;
    document.body.appendChild(iframe);

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setIsLoading(false);
    };
  };

  return (
    <BaSeShapeButton
      isLoading={isLoading}
      buttonType="button"
      color={color}
      nameIcon="print"
      onClick={PDFBlobPrint}
      shape="square"
      size="medium"
      sizeIcon="medium"
      type="tertiary"
      popover={{
        direction: 'top',
        message: 'Imprimir certificado',
      }}
    />
  );
};
